export default __webpack_public_path__ + "3e2484b4af107a1c32d1fc856e336e2f.svg";